const activeClass = 'active';
const bodySelector = '.collapsible-body';
const groupSelector = '.collapsible-group';
const headerSelector = '.collapsible-header';
const contentSelector = '.collapsible-content';
const itemSelector = '.collapsible';
const standaloneSelector = `${itemSelector}.standalone`;
const animationDuration = 200;

let updateAriaLabels = (el, open) => {
  const header = el.querySelector(headerSelector);
  header.setAttribute('aria-expanded', `${open}`);
};

const closeCollapsible = (el) => {
  if (el.classList.contains(activeClass)) {
    const body = el.querySelector(bodySelector);
    body.style.height = '0px';
    el.classList.remove(activeClass);
    updateAriaLabels(el, false);
    setTimeout(() => {
      body.style.removeProperty('height');
    }, animationDuration);
  }
};

let openCollapsible = (el) => {
  const offsetHeight = el.querySelector(contentSelector).offsetHeight;
  const body = el.querySelector(bodySelector);
  body.style.height = `${offsetHeight}px`;
  el.classList.add(activeClass);
  updateAriaLabels(el, true);
};

const animateCollapsible = (el, siblings) => {
  el.querySelector(headerSelector).addEventListener('click', () => {
    const isActive = el.classList.contains(activeClass);
    if (siblings) {
      siblings.forEach(sibling => closeCollapsible(sibling));
    }
    if (!isActive) {
      openCollapsible(el);
    } else if (!siblings) {
      closeCollapsible(el);
    }
  });
};

export const initCollapsible = (targetEl) => {
  const target = targetEl || document;
  const lists = target.querySelectorAll(groupSelector);
  const standalone = target.querySelectorAll(standaloneSelector);
  lists.forEach((wrapper) => {
    const collapsibles = wrapper.querySelectorAll(itemSelector);
    collapsibles.forEach((el) => {
      animateCollapsible(el, collapsibles);
    });
  });
  standalone.forEach(el => animateCollapsible(el, false));
};
